export default {
  bookingData: null,
  tokenCard: null,
  billingAddress: null,
  requirePayment: null,
  reschedule: null,
  error: null,
}
